(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DialogService', DialogService);

    DialogService.$inject = ['$resource', '$mdDialog'];

    function DialogService($resource, $mdDialog) {

        return {
            showAlert: showAlert,
            showConfirm: showConfirm,
            showConfirmV2: showConfirmV2,
            showDialog: showDialog
        }

        function showDialog(templateUrl, scope) {

            return $mdDialog.show({
                clickOutsideToClose: true,
                scope: scope,
                preserveScope: true,
                templateUrl: templateUrl,
                controller: ['$scope', '$mdDialog', DialogController]
            });

        }

        function DialogController(scope, $mdDialog) {
            scope.closeDialog = function () {
                $mdDialog.hide();
            }
        }

        // DialogController.$inject = ['$scope','$mdDialog'];
        //function showDialog(controller,templateUrl)
        //{
        //  return  $mdDialog.show({
        //            controller: controller,
        //            templateUrl: templateUrl,
        //            parent: angular.element(document.body),
        //        //    targetEvent: ev,
        //            clickOutsideToClose:true,
        //            fullscreen: false // Only for -xs, -sm breakpoints.
        //        });
        //
        //}
        function showConfirm(title, contentText, okText, cancelText) {
            if (!contentText) contentText = '';
            if (!okText) okText = 'تایید';
            if (!cancelText) cancelText = 'انصراف';


            var confirm = $mdDialog.confirm({
                onComplete: function () {
                    angular.element(document.querySelector("button[ng-click='dialog.hide()']")).addClass(' md-raised ');
                    angular.element(document.querySelector("button[ng-click='dialog.abort()']")).addClass('md-warn');
                }
            })
                .title(title)
                .textContent(contentText)
                .ariaLabel('')
                // .targetEvent(event)
                .ok(okText)
                .cancel(cancelText);

            return $mdDialog.show(confirm)

        }

        function showAlert(title, contentText, okText) {
            if (!contentText) contentText = '';
            if (!okText) okText = 'تایید';
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(title)
                    .textContent(contentText)
                    .ariaLabel('Offscreen Demo')
                    .ok(okText)
                    // Or you can specify the rect to do the transition from
                    .openFrom({
                        top: -50,
                        width: 30,
                        height: 80
                    })
                    .closeTo({
                        left: 1500
                    })
            );

        }

        function showConfirmV2(title, contentText, okText, cancelText) {
            if (!contentText) contentText = '';
            if (!okText) okText = 'تایید';
            if (!cancelText) cancelText = 'انصراف';


            var confirm = $mdDialog.confirm({
                onComplete: function () {

                    angular.element(document.querySelector("button[ng-click='dialog.hide()']")).addClass(' md-raised pl-btn-primary pl-btn pl-btn-md ');
                    angular.element(document.querySelector("button[ng-click='dialog.abort()']")).addClass('md-warn pl-btn');
                }
            })
                .title(title)
                .textContent(contentText)
                .ariaLabel('')
                // .targetEvent(event)
                .ok(okText)
                .cancel(cancelText);

            return $mdDialog.show(confirm)

        }

        return service;
    }
})();
